import { FormControl, FormMessage, FormField, FormItem } from '@ui/components';
import { FieldValues, Control, Path } from 'react-hook-form';
import { ReactNode } from 'react';
import { cn } from '@ui/utils';

import { AssignTableProps, AssignTable } from './assign-table';
import { UseAssignTable } from './use-assign-table';

interface IFormSelectProps<T extends FieldValues = FieldValues, D = unknown>
  extends UseAssignTable<D> {
  text: AssignTableProps<D>['text'];
  itemTemplate: (item: D) => ReactNode;
  hideErrorMessage?: boolean;
  formControl: Control<T>;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  name: Path<T>;
}

export function FormAssignTable<T extends FieldValues, D = unknown>({
  hideErrorMessage,
  itemTemplate,
  formControl,
  className,
  isLoading,
  combobox,
  disabled,
  getRowId,
  table,
  text,
  name,
}: IFormSelectProps<T, D>) {
  return (
    <FormField
      render={({ field }) => {
        return (
          <FormItem className={cn('relative z-0', className)}>
            <FormControl>
              <AssignTable
                onSelectedChange={(value) => {
                  field.onChange(value);
                }}
                itemTemplate={itemTemplate}
                selected={field.value}
                isLoading={isLoading}
                disabled={disabled}
                combobox={combobox}
                getRowId={getRowId}
                table={table}
                text={text}
              />
            </FormControl>
            {!hideErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
      control={formControl}
      name={name}
    />
  );
}
